/* eslint-disable no-param-reassign */
import { Subscription } from '@front/common/types'

type cartItem = Subscription

interface Istate {
  cart: cartItem[]
  isInitialized: boolean
}

const initialState = (): Istate => ({
  cart: [],
  isInitialized: false,
})

export default {
  namespaced: true,
  state: initialState,
  getters: {
    get: (state: Istate) => state.cart,
    getSubscription: (state: Istate) => state.cart[0],
    isInitialized: (state: Istate) => state.isInitialized,
  },
  mutations: {
    set(state: Istate, payload: cartItem) {
      state.cart = [...state.cart, payload]
    },
    setIsInitialized(state: Istate, value: boolean) {
      state.isInitialized = value
    },
    reset(state: Istate) {
      state.cart = []
    },
    update(state: Istate, payload: cartItem) {
      state.cart = state.cart.map((item) =>
        item.id === payload.id ? payload : item,
      )
    },
  },
  actions: {
    setIsInitialized({ commit }, payload: boolean) {
      commit('setIsInitialized', payload)
    },
    async update({ commit }, payload) {
      commit('update', payload)
    },
    async upsert({ commit, state }, payload: cartItem) {
      const existingItem = state.cart.some(({ id }) => id === payload.id)

      if (existingItem) {
        commit('update', payload)
      } else {
        commit('set', payload)
      }
    },
  },
}
